import type { StorefrontProduct } from '../../../shared/types/api';

interface ProductCardProps {
  product: StorefrontProduct;
  onOpen: () => void;
}

export function ProductCard({ product, onOpen }: ProductCardProps) {
  const image = product.images[0];
  return (
    <article className="store-product-card">
      <button
        className="product-art"
        type="button"
        onClick={onOpen}
        aria-label={`View ${product.name}`}
      >
        {image ? <img src={image.url} alt={image.altText} /> : <span aria-hidden="true">✦</span>}
      </button>
      <div className="product-card-copy">
        <p className="product-species">{product.species.commonName}</p>
        <h3>
          <button type="button" onClick={onOpen}>
            {product.name}
          </button>
        </h3>
        <p>{product.description}</p>
        <div className="product-card-footer">
          <span className="product-listing-status">
            Coming soon — Amazon listing not yet available
          </span>
          <button className="store-button store-button-small" type="button" onClick={onOpen}>
            View bracelet
          </button>
        </div>
      </div>
    </article>
  );
}
